import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { PhoneIcon } from '../../../../../common/icons/redesignIcons';

import './AssistanceStrip.css';

const CalendarIcon = () => (
  <svg width={17} height={17} viewBox="0 0 24 24" fill="none" stroke="var(--teal-d)" strokeWidth="2" style={{ flex: 'none' }}>
    <rect x="3" y="4" width="18" height="18" rx="2" />
    <path d="M16 2v4M8 2v4M3 10h18" />
  </svg>
);

const ClockIcon = () => (
  <svg width={17} height={17} viewBox="0 0 24 24" fill="none" stroke="var(--teal-d)" strokeWidth="2" style={{ flex: 'none' }}>
    <circle cx="12" cy="12" r="9" />
    <path d="M12 7v5l3 2" />
  </svg>
);

const MailIcon = () => (
  <svg width={17} height={17} viewBox="0 0 24 24" fill="none" stroke="var(--teal-d)" strokeWidth="2" style={{ flex: 'none' }}>
    <rect x="2" y="4" width="20" height="16" rx="2" />
    <path d="m2 7 10 6 10-6" />
  </svg>
);

@inject('translationsStore')
@observer
class AssistanceStrip extends Component {
  render() {
    const { translationsStore, onContactusClick, onEmailClick } = this.props;

    return (
      <div className="AssistanceStrip">
        <span className="AssistanceStripTitle">{translationsStore.translate('movein.assistance.title')}</span>
        <div className="AssistanceStripItems">
          <div className="AssistanceStripItem">
            <CalendarIcon />
            <span>{translationsStore.translate('movein.stepWelcome.tilesSupport.weekdays.title')}</span>
          </div>
          <div className="AssistanceStripItem">
            <ClockIcon />
            <span>{translationsStore.translate('movein.stepWelcome.tilesSupport.time.title')}</span>
          </div>
          <div className="AssistanceStripItem clickable" onClick={onContactusClick}>
            <PhoneIcon size={17} />
            <span>
              {translationsStore.translate('movein.header.tollFreeNumber')} · {translationsStore.translate('movein.stepWelcome.tilesSupport.phone.landlineFirst')}
            </span>
          </div>
          <div className="AssistanceStripItem clickable" onClick={onEmailClick}>
            <MailIcon />
            <span>movein@myair.io</span>
          </div>
        </div>
      </div>
    );
  }
}

export default AssistanceStrip;
